import React from "react";
import styled from "styled-components";
import { Icon } from "../../Icon";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { leagueClientSkin } from "../skins/league-client";
import { playSkin } from "../skins/play-theme";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { arcaneSkin } from "../skins/arcane";
import { ContentEngagement } from "../../ContentEngagement";
import { generateLinkAnalytics } from "../../../functional/analyticsUtils";
import { isValidIcon } from "./helpers";
export const StylableCTA = ({ className, variant = "primary", ornamental = false, disabled = false, action, children, title, accessibilityText, icon, ...btnProps }) => {
    const classNames = [className, `variant-${variant}`, ornamental && "ornamental", disabled && "disabled"]
        .filter(Boolean)
        .join(" ");
    const normalizedAction = action ??
        (btnProps.href
            ? {
                type: "weblink",
                payload: {
                    url: btnProps.href || "",
                    isExternal: btnProps.target === "_blank",
                },
            }
            : undefined);
    return (React.createElement(ContentEngagement, { action: normalizedAction, contentAnalytics: generateLinkAnalytics({ title, action: normalizedAction }, `${variant}CTA`), className: classNames, "data-testid": `cta-${variant}`, "aria-label": accessibilityText, disabled: disabled, ...btnProps },
        React.createElement("div", { className: "cta-content", "data-testid": "cta-content" },
            variant !== "tertiary" && isValidIcon(icon) && React.createElement(Icon, { name: icon, className: "left-icon" }),
            React.Children.count(children) > 0 ? children : title,
            variant === "tertiary" && (React.createElement(Icon, { name: isValidIcon(icon) ? icon : "link", className: "tertiary-icon", "data-testid": "tertiary-icon" })))));
};
export const CTA = styled(StylableCTA) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.Arcane]: arcaneSkin,
    [SkinId.RiotProductLion]: lionSkin,
    [SkinId.LeagueClient]: leagueClientSkin,
    [SkinId.PlayTheme]: playSkin,
})}
`;
//# sourceMappingURL=CTA.js.map